import { render, staticRenderFns } from "./FormularioCancelamento.vue?vue&type=template&id=5a71d582&scoped=true"
import script from "./FormularioCancelamento.vue?vue&type=script&lang=js"
export * from "./FormularioCancelamento.vue?vue&type=script&lang=js"
import style0 from "./FormularioCancelamento.vue?vue&type=style&index=0&id=5a71d582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71d582",
  null
  
)

export default component.exports